document.addEventListener('DOMContentLoaded', function () {
  // console.log('dom loaded00000000000000000000000');
  // document.addEventListener('input', function (e) {
  //   console.log('input changes');
  //   if (e.target.classList.contains('cart-note-input')) {
  //     const inputVal = e.target.value;
  //     const cartattributeinput = document.querySelector('#cart-note-attr');
  //     if (cartattributeinput) {
  //       cartattributeinput.value = inputVal;
  //       console.log('value updated',inputVal)
  //       console.log('input value after',cartattributeinput)
  //     }
  //   }
  // });
  const cartInputnote = document.querySelector('.cart-note-input')
if(cartInputnote){ 
  const inputVal = cartInputnote;
      const cartattributeinput = document.querySelector('#cart-note-attr');
      if (cartattributeinput) {
        cartattributeinput.value = inputVal;
      }
}

});


document.addEventListener('DOMContentLoaded', function() {
  const INACTIVITY_TIMEOUT = 5 * 60 * 1000; // 5 minutes
  let inactivityTimer;
  const redirectUrl = '/pages/order-tiffin';

  // ===== 1. Handle Tab Close =====
  window.addEventListener('beforeunload', function() {
    localStorage.setItem('cartClearTime', Date.now());
  });

  // Check for expired cart on page load
  const clearTime = localStorage.getItem('cartClearTime');
  if (clearTime && (Date.now() - clearTime) > INACTIVITY_TIMEOUT) {
    clearCartAndRedirect();
  }

  // ===== 2. Handle User Inactivity =====
  function resetInactivityTimer() {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(clearCartAndRedirect, INACTIVITY_TIMEOUT);
  }

  // Activity listeners
  ['mousemove', 'keydown', 'scroll', 'click', 'touchstart'].forEach(event => {
    window.addEventListener(event, resetInactivityTimer);
  });

  // Start initial timer
  resetInactivityTimer();

  // ===== Combined Clear & Redirect Function =====
  function clearCartAndRedirect() {
    fetch('/cart/clear', {
      method: 'POST',
      credentials: 'same-origin'
    })
    .then(() => {
      localStorage.removeItem('cartClearTime');
      window.location.href = redirectUrl;
    })
    .catch(error => console.error('Error:', error));
  }

  // Show warning 1 minute before clearing (optional)
  setTimeout(() => {
    console.log('Your cart will be cleared in 1 minute due to inactivity');
  }, INACTIVITY_TIMEOUT - 60000);
});

// document.addEventListener('DOMContentLoaded', async function() {
//   // Check for cart clearance flag
//   const shouldClear = await fetch('/cart')
//     .then(res => res.json())
//     .then(cart => {
//       return cart.attributes?.cartCleared === 'true';
//     });

//   if (shouldClear) {
//     // Clear the cart
//     await fetch('/cart/clear', { method: 'POST' });
    
//     // Remove the attribute
//     await fetch('/cart/update', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         attributes: { cartCleared: null }
//       })
//     });
//   }
// });